import React from "react";

export enum TableActionTypes {
    SET_SORTED_DATA = 'SET_SORTED_DATA',
    SET_SELECTED_ROW_KEYS = 'SET_SELECTED_ROW_KEYS',
    SET_SORT_ORDER_MAP = 'SET_SORT_ORDER_MAP',
}

export interface TableState<T> {
    selectedRowKeys: Record<string, React.Key[]>,
    sortOrderMap: Record<string, 'ascend' | 'descend' | null>,
    sortedData: T[]
}

interface SetSortedDataAction<T> {
    type: TableActionTypes.SET_SORTED_DATA,
    payload: T[]
}

interface SetSortOrderMapAction {
    type: TableActionTypes.SET_SORT_ORDER_MAP,
    payload: Record<string, 'ascend' | 'descend' | null>
}

interface SetSelectedRowKeysAction {
    type: TableActionTypes.SET_SELECTED_ROW_KEYS,
    payload: Record<string, React.Key[]>
}

export type TableActions<T> = SetSortedDataAction<T> | SetSortOrderMapAction | SetSelectedRowKeysAction;